module.exports = __webpack_public_path__ + "img/1_009.81963b13.jpg";